const baseURL = 'https://superrichard.kexe.mx/';

export default baseURL;
